var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "label",
    {
      attrs: {
        id: "stock-images-upload-box-drag-area",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "holder",
          class: {
            dragging: _vm.dragging,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "box-centered",
            },
            [
              _c(
                "div",
                {
                  staticClass: "icon-upload",
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: "upload",
                      size: 100,
                      alt: "",
                      role: _vm.dragging ? "info_alt" : "clickable",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.$gettext(
                      "Bild auswählen oder per Drag & Drop hierher ziehen"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "upload-button-holder",
                },
                [
                  _c("input", {
                    ref: "upload",
                    attrs: {
                      type: "file",
                      name: "file",
                      tabindex: "-1",
                      accept: "image/*",
                    },
                    on: {
                      change: _vm.onUpload,
                      dragenter: function dragenter($event) {
                        return _vm.setDragging(true)
                      },
                      dragleave: function dragleave($event) {
                        return _vm.setDragging(false)
                      },
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }